var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaggage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 22.875C6.22385 22.875 6 22.6512 6 22.375V6.375C6 6.09885 6.22385 5.875 6.5 5.875H6.75C7.02615 5.875 7.25 5.65115 7.25 5.375V4.125C7.25 2.46814 8.59314 1.125 10.25 1.125H13.75C15.4069 1.125 16.75 2.46814 16.75 4.125V5.375C16.75 5.65115 16.9738 5.875 17.25 5.875H17.5C17.7762 5.875 18 6.09885 18 6.375V22.375C18 22.6512 17.7762 22.875 17.5 22.875H6.5ZM10.25 3.125C9.69772 3.125 9.25 3.57272 9.25 4.125V5.375C9.25 5.65115 9.47385 5.875 9.75 5.875H14.25C14.5262 5.875 14.75 5.65115 14.75 5.375V4.125C14.75 3.57272 14.3023 3.125 13.75 3.125H10.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.375C4 6.09886 3.77614 5.875 3.5 5.875C1.567 5.875 0 7.442 0 9.375V19.375C0 21.308 1.567 22.875 3.5 22.875C3.77614 22.875 4 22.6511 4 22.375V6.375Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 5.875C20.2239 5.875 20 6.09886 20 6.375V22.375C20 22.6511 20.2239 22.875 20.5 22.875C22.433 22.875 24 21.308 24 19.375V9.375C24 7.442 22.433 5.875 20.5 5.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaggage);
export default __webpack_public_path__ + "static/media/baggage.2e74f62f.svg";
export { ForwardRef as ReactComponent };